import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

interface IPostCoachingSummaryBody {
  candidateId: ObjectId;
  content: string;
}

export const usePostCoachingSummaryPDF = () => {
  const [state, execute, cancel] = axios<string, IPostCoachingSummaryBody[], unknown>(
    {
      url: "/summary/coaching",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostCoachingSummaryBody[]) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
